<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">THE HISTORY OF JERUSALEM</p>
<p class="halfa">ITS ORIGINS TO THE EARLY MIDDLE AGES</p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?1808c4a1